export const isBrandAppPath = path => /^\/brand-(?:console(?:\/|$)|login(?:\/|$)|register(?:\/|$))/.test(path);
export const BRAND_APP = isBrandAppPath(window.location.pathname);
